import React, { Component } from 'react';

import NotesFeatureItem from "./NotesFeatureItem";
import LockScreen from "./LockScreen";
export default class NotesFeatures extends Component {

    constructor(props) {
        super(props);

        this.getRowsData = this.getRowsData.bind(this);
        this.state = { isLocked: false, };
    }

    handleLock = (islock) => {
        this.setState({ isLocked: islock });
    };

    getRowsData = function (features, rows) {
        return rows.map((row, index) => {
            return <table>
                <tbody><tr><RenderRow handleUpdate={this.props.handleUpdate} updateConfiguration={this.props.updateConfiguration}
                    configurationId={this.props.configurationId} notesId={this.props.notesId} features={features}
                    key={index} columns={row.columns} extDisable={this.props.extDisable}
                    handleLock={this.handleLock} /></tr> </tbody>
            </table>
        })
    }

    render() {
        const debug = this.props.debug;
        const groups = this.props.groups;
        const features = this.props.features;

        return (
            <LockScreen isLocked={this.state.isLocked}>
                <div className="features">
                    {groups.map((group, index) => (
                        <div class="cdsFeatureItem">
                            <div class="cdsFeatureItemHeader">
                                {group.label}
                            </div>
                            {/* {this.getRowsData(features, group.lists.filter(list => { return list.row === 1 }))}*/}
                            {/*<table>*/}
                            {/*    <tbody>*/}
                            {this.getRowsData(features, group.rows)}
                            {/*    </tbody>*/}
                            {/*</table>*/}
                        </div>
                    ))}
                </div>
            </LockScreen>
        );

    }
}

const RenderRow = (props) => {

    return props.columns.map((key, index) => {
        if (key.idCDSParameter != null) {
            let f = props.features.find(feature => { return feature.id === key.idCDSParameter });
            if (!f)
                this.props.showError({ name: "������ ������ ��������", message: '�� ������� �������� �� id ' + key.idCDSParameter });

            if (f && (f.visible == undefined || f.visible == true)) {
                let difference = "";
                let differenceCDS = {};
                if (f.type == 'numericUpDown') {
                    if (f.difference != "" && f.difference != undefined && f.difference > 0 && f.differenceCDSId != undefined) {
                        difference = f.difference;
                        differenceCDS = props.features.find(feature => { return feature.id === f.differenceCDSId });
                    }
                }
                return <td className="cdsCell" colSpan={key.columnSpan}><NotesFeatureItem extDisable={props.extDisable} configurationId={props.configurationId}
                    notesId={props.notesId} autoSize={key.autoSize} feature={f}
                    handleUpdate={props.handleUpdate} updateConfiguration={props.updateConfiguration}
                    difference={difference} differenceDescription={differenceCDS.description}
                    handleLock={props.handleLock} showError={props.showError}
                /></td>
            }
            else {
                return <td className="cdsCell" colSpan={key.columnSpan}></td>
            }
        } else {
            return <td className="cdsCell" colSpan={key.columnSpan}></td>
        }
    })
}
